import Vue from 'vue';
import App from './App.vue';
import './directives/outside-click.directive';
import './filters/formatDate';
import { store } from './store';

Vue.config.productionTip = false;

new Vue({
    store,
    render: (h) => h(App),
}).$mount('#dynamiclist-app');
